import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PeepingLogo } from "@/components/PeepingLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-screen" className="relative min-h-screen bg-[#080808] grain">
      <div className="mx-auto flex min-h-screen w-full max-w-md flex-col px-6 pb-10 pt-8">
        <Link to="/login" className="text-[#a7a0af] hover:text-white">
          <ArrowLeft size={22} />
        </Link>
        <div className="mt-8 flex flex-col items-center">
          <PeepingLogo className="w-44" />
        </div>

        {sent ? (
          <div data-testid="forgot-confirmation" className="mt-12 rounded-2xl glass p-6 text-center">
            <h1 className="text-xl font-bold">Check your inbox</h1>
            <p className="mt-2 text-sm text-[#a7a0af]">
              If that email is registered, a reset link has been sent. The link expires in one hour.
            </p>
            <Link to="/login" className="mt-6 inline-block text-sm font-semibold text-[#d42be8]">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <div className="mt-10">
              <h1 className="text-2xl font-bold">Reset password</h1>
              <p className="mt-1 text-sm text-[#a7a0af]">
                Enter your email and we'll send you a recovery link.
              </p>
            </div>
            <form onSubmit={submit} className="mt-6 flex flex-col gap-3" noValidate>
              <div className="relative">
                <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#a7a0af]" />
                <input
                  data-testid="forgot-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                  className="field w-full rounded-2xl py-4 pl-11 pr-4 text-sm"
                />
              </div>
              {error && <p className="text-sm text-red-300">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit"
                className="btn-brand mt-2 w-full rounded-2xl py-4 text-base font-semibold text-white"
              >
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <Link to="/login" className="mt-6 text-center text-sm font-semibold text-[#d42be8]">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
